import { render, staticRenderFns } from "./ImagesWidget.vue?vue&type=template&id=2e3adeb4&scoped=true"
import script from "./ImagesWidget.vue?vue&type=script&lang=js"
export * from "./ImagesWidget.vue?vue&type=script&lang=js"
import style0 from "./ImagesWidget.vue?vue&type=style&index=0&id=2e3adeb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3adeb4",
  null
  
)

export default component.exports